import _toConsumableArray from "/tmp/builds/4f00de09-012a-4fbc-9f66-73f250170007-develop-nodeV18-18/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import { useRef } from "react";
/** Like react's useMemo but with guarantee that the fn
 * won't be invoked again if deps hasn't change */

export function useGuaranteedMemo(fn, deps) {
  var ref = useRef();

  if (!ref.current || deps.length !== ref.current.prevDeps.length || ref.current.prevDeps.map(function (v, i) {
    return v === deps[i];
  }).indexOf(false) >= 0) {
    ref.current = {
      "v": fn(),
      "prevDeps": _toConsumableArray(deps)
    };
  }

  return ref.current.v;
}